import React, { useState, useEffect } from 'react';
import { bool, func, object, number, string, PropTypes } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routeConfiguration';
import { propTypes } from '../../util/types';
import {
  Avatar,
  InlineTextButton,
  Logo,
  Menu,
  MenuLabel,
  MenuContent,
  MenuItem,
  NamedLink,
  ListingLink,
  OwnListingLink,
} from '../../components';
import { TopbarSearchForm } from '../../forms';
import { types as sdkTypes } from '../../util/sdkLoader';
import css from './TopbarDesktop.module.css';
import ReactTypeformEmbed from 'react-typeform-embed/lib/ReactTypeformEmbed';
import CommunityPopup from '../TypeformPopup/CommunityPopup';


const sharetribeSdk = require('sharetribe-flex-sdk');


const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });

const { UUID, LatLng } = sdkTypes;

const TopbarDesktop = props => {
  const {
    className,
    currentUser,
    currentPage,
    rootClassName,
    currentUserHasListings,
    currentUserListingFetched,
    currentUserListing,
    notificationCount,
    intl,
    isAuthenticated,
    onLogout,
    onSearchSubmit,
    initialSearchFormValues,
    setTextValue,
    setAthleteValue,
    setGapYearValue,
    setGreekLifeValue,
    handleSubmitSearch,
    setServiceValue,
    setTrackValue,
    setSchoolValue,
    textValue,
    showTransparent,
    hideTopbarInput,
    history,
  } = props;
  const [mounted, setMounted] = useState(false);
  const [masterListing, setMasterListing] = useState("");
  const [communityState, setCommunityState] = useState(false);

  useEffect(() => {

    setMounted(true);
    setCommunityState(false);
    sdk.ownListings.query({}).then(resp => {
      const listingsArray = resp.data.data;
      const masterListing = listingsArray.find(listing => {
        return listing.attributes.publicData.listingType === "masterListing";
      })
      return masterListing
    }).then(resp => {
      setMasterListing(resp)
    }).catch(error => { 
      console.log(error)
    })

  }, [communityState]);

  


// console.log(masterListing.attributes.title)
// console.log(masterListing.id.uuid)
  const isHelper = currentUser ? currentUser.attributes.profile.publicData.helper : false;
  // console.log(window.location.href)
  // console.log(window.location.origin)
  // const regex1 = new RegExp(`${window.location.origin}/s?keywords=`);
  // const regex2 = new RegExp(`${window.location.href}`);
  // console.log(regex1)
  // console.log(regex1.test(regex2))
  const authenticatedOnClientSide = mounted && isAuthenticated;
  const isAuthenticatedOrJustHydrated = isAuthenticated || !mounted;
 //console.log(currentUserListing)
  const classes = classNames(
    rootClassName || css.root,
    !rootClassName && showTransparent && css.rootTransparent,
    className);

  const search = (
    <TopbarSearchForm
      textValue={textValue}
      setTextValue={setTextValue}
      className={showTransparent ? css.searchLinkTransparent : css.searchLink}
      desktopInputRoot={showTransparent ? css.topbarSearchWithLeftPaddingTransparent : css.topbarSearchWithLeftPadding}
      onSubmit={onSearchSubmit}
      initialValues={initialSearchFormValues}
      setAthleteValue={setAthleteValue}
      setGapYearValue={setGapYearValue}
      setGreekLifeValue={setGreekLifeValue}
      handleSubmitSearch={handleSubmitSearch}
      setSchoolValue={setSchoolValue}
      setServiceValue={setServiceValue}
      setTrackValue={setTrackValue}
      showTransparent={showTransparent}
      hideTopbarInput={hideTopbarInput}
    />
  );

  const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;

  const inboxLink = authenticatedOnClientSide ? (
    <NamedLink
      className={showTransparent ? css.transparentInboxLink : css.inboxLink}
      name="InboxPage"
      params={{ tab: currentUserHasListings ? 'sales' : 'orders' }}
    >
      <span className={css.inbox}>
        <FormattedMessage id="TopbarDesktop.inbox" />
        {notificationDot}
      </span>
    </NamedLink>
  ) : null;

  const currentPageClass = page => {
    const isAccountSettingsPage =
      page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    return currentPage === page || isAccountSettingsPage ? css.currentPage : null;
  };

  const profileMenu = authenticatedOnClientSide ? (
    <Menu>
      <MenuLabel className={ showTransparent ?  css.profileMenuLabelTransparent :  css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
        <Avatar className={css.avatar} user={currentUser} disableProfileLink />
      </MenuLabel>
      <MenuContent className={css.profileMenuContent}>
      {/* <MenuItem key="ManageListingsPage"> */}
    {/* TODO if you want to see the dev temporary pannel again */}
          {/* <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('ManageListingsPage'))}
            name="ManageListingsPage"
          >
            <span className={css.menuItemBorder} />
             <FormattedMessage id="TopbarDesktop.yourListingsLink" />
           </NamedLink> 

        </MenuItem> */}

    {/* ____________________________________________________________________________________ */}
        <MenuItem key="EditListingPage">
          <OwnListingLink
            listing={masterListing}
            listingFetched={masterListing}
            className={css.yourListingsLink}
            >
              <div>
              <span className={css.menuItemBorder} />
              {currentUserListing ? (
                <FormattedMessage id="TopbarDesktop.editYourListingLink" />
              ) : (
                <FormattedMessage id="TopbarDesktop.addYourListingLink" />
              )}
            </div>
          </OwnListingLink>
          </MenuItem>


          {masterListing && isHelper ? 
            <MenuItem key="ViewLiveProfile">
         <button className={css.viewProfileButton} onClick={() => history.push(`/l/${masterListing.id.uuid}`)}>View live profile</button>

            </MenuItem> : <MenuItem key="empty">
            </MenuItem>

          }

          
    
    {/* ____________________________________________________________________________________ */}


{!masterListing && isHelper ?
      <MenuItem key="ContinueSignup">
         
         <button className={css.continueSignUpButton} onClick={() => history.push('/l/00000000-0000-0000-0000-000000000000/new/description')}>Personalize your services</button>
     
     </MenuItem> : <MenuItem key="ContinueSignup"></MenuItem>}
        


        {/* <MenuItem key="ProfileSettingsPage">
          <NamedLink
            className={classNames(css.profileSettingsLink, currentPageClass('ProfileSettingsPage'))}
            name="ProfileSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.profileSettingsLink" />
          </NamedLink>
        </MenuItem> */}
        <MenuItem key="AccountSettingsPage">
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('AccountSettingsPage'))}
            name="AccountSettingsPage"
          >
            
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.accountSettingsLink" />
          </NamedLink>
        </MenuItem>

        { currentUser ?  (currentUser.attributes.profile.publicData.helper ? <MenuItem key=""></MenuItem> :
          <MenuItem key="StudentProfilePage">
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('StudentProfilePage'))}
            name="StudentProfilePage"
          >
            
            <span className={css.menuItemBorder} />
            Get started
          </NamedLink>
        </MenuItem>) : <MenuItem key=""></MenuItem>
        }


        <MenuItem key="logout">
          <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.logout" />
          </InlineTextButton>
        </MenuItem>
      </MenuContent>
    </Menu>
  ) : null;

  const communityLink = isAuthenticatedOrJustHydrated ? null : (
    <button onClick={() => setCommunityState(true)} className={showTransparent ? css.communityLinkTransparent : css.communityLink} >
      <span className={css.community}>
        <FormattedMessage id="TopbarDesktop.community" />
      </span>
    </button>
  );


  const signupLink = isAuthenticatedOrJustHydrated ? null : (
    <NamedLink name="SignupPageHelper" className={showTransparent ? css.signupLinkTransparent : css.signupLink}>
      <span className={css.signup}>
        <FormattedMessage id="TopbarDesktop.signup" />
      </span>
    </NamedLink>
  );

  const loginLink = isAuthenticatedOrJustHydrated ? null : (
    //____________________________________________________________________________________________________________
    <NamedLink name="LoginPage" className={showTransparent ? css.loginLinkTransparent : css.loginLink}>
      <span className={css.login}>
        <FormattedMessage id="TopbarDesktop.login" />
      </span>
    </NamedLink>
 
  );


  const listingLink =
    authenticatedOnClientSide && currentUserListingFetched && currentUserListing ? (
      <ListingLink
        className={css.createListingLink}
        listing={currentUserListing}
        children={
          <span className={css.createListing}>
            <FormattedMessage id="TopbarDesktop.viewListing" />
          </span>
        }
      />
    ) : null;


  const createListingLink =
  isAuthenticatedOrJustHydrated && !(currentUserListingFetched && !currentUserListing) ? null : (
      <NamedLink className={css.createListingLink} name="NewListingPage">
        <span className={css.createListing}>
          <FormattedMessage id="TopbarDesktop.createListing" />    
        </span>
      </NamedLink>
    );
  return (
    <nav className={classes}>
      <NamedLink className={showTransparent ? css.logoLinkTransparent : css.logoLink} name="LandingPage">
        <Logo
          format="desktop"
          className={showTransparent ? css.logoTransparent : css.logo}
          alt={intl.formatMessage({ id: 'TopbarDesktop.logo' })}
          showTransparent={showTransparent}
        />
      </NamedLink>
      <div className={css.topbarLeftItems}>
      {search}
      {/* {listingLink} */}
      {/* {createListingLink} */}
      {inboxLink}
      {profileMenu}
        {communityLink}
       {communityState && <CommunityPopup />}
      {/* {signupLink}
      {loginLink} */}
      </div>
    </nav>
  );
};

TopbarDesktop.defaultProps = {
  rootClassName: null,
  className: null,
  currentUser: null,
  currentPage: null,
  currentUserListing: null,
  notificationCount: 0,
  initialSearchFormValues: {},
  currentUserListingFetched: false,
};

TopbarDesktop.propTypes = {
  rootClassName: string,
  className: string,
  currentUserHasListings: bool.isRequired,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,
  currentUser: propTypes.currentUser,
  currentPage: string,
  isAuthenticated: bool.isRequired,
  onLogout: func.isRequired,
  notificationCount: number,
  onSearchSubmit: func.isRequired,
  initialSearchFormValues: object,
  intl: intlShape.isRequired,
};

export default TopbarDesktop;
